// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__132Fu","title":"AfterBackImages_title__1yacR","images":"AfterBackImages_images__Qioy4"};